<template>
  <div class="app-container">
    <!-- 页面内容 -->
    <div class="container-page">

      <!-- 筛选条件 -->
      <div class="filter-container filter-box filter-flex">
        <div class="left-box">
          <!-- 外包商模糊搜索 -->
          <el-input class="filter-item input_search" v-model="listQuery.keyword" placeholder="外包商模糊搜索" clearable @keyup.enter.native="handleFilter" @input="handleFilter" @clear="handleFilter" style="width: 240px">
            <svg-icon slot="prefix" class="el-input__icon icon" icon-class="search_shape" />
          </el-input>

          <!-- 是否合作= -->
          <el-select class="filter-item" v-model="listQuery.isCooperates" @change="handleFilter" multiple clearable collapse-tags placeholder="是否合作" style="width: 160px">
            <el-option v-for="item in isCooperateOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>

          <!-- 岗位分类 =-->
          <el-select class="filter-item select-box" v-model="listQuery.positionTypes" @change="handleFilter" filterable multiple clearable collapse-tags placeholder="岗位分类" style="width: 160px">
            <el-option v-for="item in postTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>

          <!-- 风格标签 -->
          <el-select class="filter-item select-box" v-model="listQuery.styleLabels" @change="handleFilter" filterable multiple clearable collapse-tags placeholder="风格标签" style="width: 160px">
            <el-option v-for="item in styleLabelsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>

          <!-- 技术特长 -->
          <el-select class="filter-item select-box" v-model="listQuery.technologys" @change="handleFilter" clearable filterable multiple collapse-tags placeholder="技术特长" style="width: 160px">
            <el-option v-for="item in technologysOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>

          <!-- 合作英雄项目= -->
          <el-select class="filter-item select-box" v-model="listQuery.heroProjects" @change="handleFilter" multiple clearable filterable collapse-tags placeholder="合作英雄项目" style="width: 160px">
            <el-option v-for="item in projectOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>

        </div>

        <div class="right-box">

          <!-- 操作按钮 -->
          <div class="filter-container filter-box">

            <el-button class="filter-item button_download" :loading="downloadLoading" v-if="accessPoint['outsource:download']" @click="handleDownload">
              <svg-icon icon-class="download_shape" />
              <span class="button_span">下载</span>
            </el-button>

            <el-popover width="400" trigger="click" style="margin:0 15px">
              <el-button slot="reference" class="filter-item button_filter">
                <svg-icon icon-class="combined_shape" />
                <span class="button_span_style">筛选列</span>
              </el-button>

              <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
                <el-checkbox v-for="(item, index) in tableTheadOptions" :key="index" :label="item" :disabled="index == 0">{{ item[Object.keys(item)[0]] }}</el-checkbox>
              </el-checkbox-group>
            </el-popover>

            <el-button class="filter-item button_add" type="primary" @click="handleAdd" v-if="accessPoint['outsource:create']">
              <i class="el-icon-plus" />
              <span class="button_span">添加新外包</span>
            </el-button>

          </div>

        </div>
      </div>

      <!-- 表格 -->
      <el-table ref="table" class="grayTableTile_02" v-loading="tableloading" :data="tableList" :show-overflow-tooltip="true" :header-cell-style="{'background-color':'#f7f7f7','color':'#999'}" @sort-change="sortFun" height='635'
        >
        <el-table-column v-for="(item, index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" :fixed="(index == 0 || index == 1) && tableList.length>0"
          :sortable="item['sortable']" show-overflow-tooltip :min-width="
            Object.keys(item)[0] == 'name'|| Object.keys(item)[0] == 'modifyTime'
              ? 240
              : 150
          ">
          <template slot-scope="scope">
            <span v-if="scope.row[Object.keys(item)[0]]" @click="previewFun(scope.row[Object.keys(item)[0]])">{{ scope.row[Object.keys(item)[0]] }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column :fixed="tableList.length>0?'right':false" align="right" header-align="right" label="操作" width="100" v-if="accessPoint['outsource:edit'] || accessPoint['outsource:delete']">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)" v-if="accessPoint['outsource:edit']">编辑</el-button>
            <div class="line" v-if="accessPoint['outsource:edit'] && accessPoint['outsource:delete']"></div>
            <el-button type="text" @click="handleDelete(scope.row)" v-if="accessPoint['outsource:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination class="pagination" style="padding-bottom:0px" v-show="total > 0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize"  />
    </div>

    <!-- 添加 编辑 -->
    <add-editor-manage ref="add_editor"></add-editor-manage>

    <el-dialog :visible.sync="dialogVisible" title="详情" width='33%'>
      <ul>
        <li v-for="(item,index) of dialogContent" :key='index' class="liClass">
          {{item}}
        </li>
      </ul>

    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import AddEditorManage from "./components/addEditorManage.vue";
import { outsource_outsourcerList, config_outsourcerLabel, outsource_deleteOutsourcer } from "@File~/api/outsourcing";
import { projectList_ajax } from "@File~/api/file";
import { arrSlice, sortKeys } from '@/filters'
import { downloadCurrentData } from '@/utils'



const defaultFormThead = [
  { name: "外包商名称", sortable: "custom" },
  { isCooperateStr: "是否合作", sortable: "custom" },
  { typeName: "外包商类型", sortable: "custom" },
  { positionTypeStr: "岗位分类", sortable: "custom" },
  { isNewAgreementStr: "是否已签新外包协议" },
  { inListTimeStr: "入榜时间", sortable: "custom" },
  { gradeName: "规模评级" },
  { website: "公司网址" },
  { address: "公司地址" },
  { telephone: "联系方式" },
  { worksUrl: "作品集" },
  { companySize: "公司规模（人数）" },
  { styleLabelName: "风格标签" },
  { technologyName: "技术特长" },
  { outResources: "外单资源" },
  { isHeroCollaboratorName: "是否和英雄合作" },
  { heroProjectName: "英雄项目" },
  { competitiveProducts: "市场对标竞品" },
  { attendedProject: "参与过项目" },
  { totalScore: "总分" },
  { materialUrl: "素材链接" },
  { remarks: "备注" },
  { modifyTime: "更新时间", sortable: "custom" },
];

export default {
  components: { Pagination, AddEditorManage },
  data() {
    return {
      dialogVisible: false,
      dialogContent: [],


      accessPoint: this.$store.getters.accessPoint, //权限点

      styleLabelsOptions: [],
      technologysOptions: [],
      gradesOptions: [],
      isHeroCollaboratorsOptions: [{ id: '1', name: '是' }, { id: '-1', name: '否' }],
      typesOptions: [],
      isCooperateOptions: [],
      postTypeOptions: [],
      isNewCollaboratorsOptions: [],
      projectOptions: [],

      downloadLoading: false,

      tableTheadOptions: defaultFormThead, // 筛选列
      checkboxTitle: defaultFormThead, // 默认选中

      // 表格
      tableloading: false,
      tableTheads: defaultFormThead,

      originalCaseTable: [], // 原始数据
      caseTable: [],// 排序后数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据

      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10,
        keyword: "",
        isCooperates: [],
        positionTypes: [],
        styleLabels: [],
        technologys: [],
        heroProjects: [],
      },
    };
  },
  computed: {
    // 筛选列表表
    tableList() {
      let caseTable = this.caseTable
      if (caseTable.length > 0) {
        this.total = caseTable.length
        // 将一维数组切割成二维数组
        this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
        this.tableData = this.handCaseTable[this.listQuery.pageNo - 1]
      } else {
        this.tableData = []
      }
      return this.tableData
    },
  },
  watch: {
    // 筛选table header
    checkboxTitle(valArr) {
      this.tableTheads = this.tableTheadOptions.filter(
        (i) => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1
      );
      // console.log('=======',this.tableTheads)
    },
  },
  created() {
    this.initSelect(1);
    this.initSelect(2);
    this.initSelect(3);
    this.initSelect(4);
    this.initSelect(5);
    this.initSelect(6);
    this.initSelect(7);
    this.getProject();
    this.getList();

  },
  methods: {
    previewFun(data) {
      this.dialogContent = []
      if (data.length > 8) {
        if (data.indexOf(',') !== -1 || data.indexOf('，') !== -1) {
          let tempArr = data.indexOf(',') !== -1 ? data.split(',') : data.split('，')
          tempArr.map((item) => {
            this.dialogContent.push(item)
          })
        } else {
          this.dialogContent.push(data)
        }
        this.dialogVisible = true;

      }


    },
    sortFun(e) {
      // this.listQuery.orderByType = e.order == 'ascending' ? 2 : 1
      // this.getList()
      if (e.order) {
        const order = e.order == 'descending' ? false : true
        this.caseTable.sort(sortKeys(e.prop, order))
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
      }
    },
    // 获取列表
    getList() {
      var tempTime1 = new Date().getTime();
      this.tableloading = true;
      let tempObj = {};
      for (let key in this.listQuery) {
        tempObj[key] = this.listQuery[key]
      }
      tempObj['inListTimeStr'] = tempObj['inListTimeStr'] && tempObj['inListTimeStr'].length > 0 ? tempObj['inListTimeStr'].join(' - ') : '';
      outsource_outsourcerList(tempObj).then((response) => {
        if (response.code == 1) {
          console.log(new Date().getTime() - tempTime1);
          this.total = response.data.length;
          response.data.map((item) => {
            item.isHeroCollaboratorName = item.isHeroCollaborator === 1 ? '是' : item.isHeroCollaborator === -1 ? '否' : '';
          })

          this.caseTable = response.data;
          this.originalCaseTable = JSON.parse(JSON.stringify(response.data))
          this.$refs.table.clearSort()
          // this.tableData = response.data.result;
          this.tableloading = false;
        }
      });
    },

    initSelect(data) {
      config_outsourcerLabel(data).then((response) => {
        if (response.code == 1) {
          switch (data) {
            //规模评级
            case 1:
              this.gradesOptions = response.data;
              break;
            //风格标签
            case 2:
              this.styleLabelsOptions = response.data;
              break;
            //技术特长
            case 3:
              this.technologysOptions = response.data;
              break;
            //外包商类型
            case 4:
              this.typesOptions = response.data;
              break;
            //是否合作
            case 5:
              this.isCooperateOptions = response.data;
              break;
            //岗位分类
            case 6:
              this.postTypeOptions = response.data;
              break;
            //是否已签新外包协议
            case 7:
              this.isNewCollaboratorsOptions = response.data;
              break;
          }



        }
      });

    },
    // 项目列表
    getProject() {
      projectList_ajax().then(response => {
        if (response.code == 1) {
          this.projectOptions = response.data
        }
      })
    },


    // 搜索
    handleFilter() {
      this.listQuery.pageNo = 1;
      this.getList();
    },

    // 下载
    handleDownload() {
      downloadCurrentData({ name: '外包商列表' }, this.tableTheads, this.caseTable)
    },

    // 删除
    handleDelete(row) {
      this.$confirm("确定要删除该外包商吗？", "删除外包商", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "button-primary-plain",
        type: "warning",
      })
        .then(() => {
          outsource_deleteOutsourcer(row.id).then((response) => {
            if (response.code == 1) {
              this.$message({ type: 'success', message: '删除成功' })
              this.getList()
            }
          })
        })
        .catch(() => {
        });
    },

    // 添加
    handleAdd() {
      let data = {
        styleLabelsOptions: this.styleLabelsOptions,
        technologysOptions: this.technologysOptions,
        gradesOptions: this.gradesOptions,
        typesOptions: this.typesOptions,
        isCooperateOptions: this.isCooperateOptions,
        //岗位分类
        postTypeOptions: this.postTypeOptions,
        //是否已签新外包协议
        isNewCollaboratorsOptions: this.isNewCollaboratorsOptions,
        isHeroCollaboratorsOptions: this.isHeroCollaboratorsOptions,
        projectOptions: this.projectOptions,
      }
      this.$refs["add_editor"].init("add", data, null);
    },

    // 编辑
    handleEdit(row) {
      let data = {
        styleLabelsOptions: this.styleLabelsOptions,
        technologysOptions: this.technologysOptions,
        gradesOptions: this.gradesOptions,
        typesOptions: this.typesOptions,
        isCooperateOptions: this.isCooperateOptions,
        postTypeOptions: this.postTypeOptions,
        isNewCollaboratorsOptions: this.isNewCollaboratorsOptions,
        isHeroCollaboratorsOptions: this.isHeroCollaboratorsOptions,
        projectOptions: this.projectOptions,
      }
      this.$refs["add_editor"].init("edit", data, row);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  padding: 16px 32px 61px;
  min-height: calc(100vh - 50px);
  overflow: hidden;
  background: #f5f5f5;
}
.container-page {
  // height: calc(100vh - 71px);
  padding: 24px 24px;
  background: #ffffff;
  border-radius: 4px;
  position: relative;
}

.filter-box {
  .button_span {
    margin-left: 4px;
  }

  ::v-deep .el-input__inner {
    background: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    border: 1px solid #e5e5e5;
    color: #333;
  }

  // ::v-deep .el-icon-arrow-up:before {
  //   content: "\E78F";
  //   color: #666;
  // }
}

.filter-flex {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;
}

.right-box {
  flex-shrink: 0;
  width: 340px;
  text-align: right;
}

.button_filter {
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  padding: 10px 12px;
}

// input search
.input_search {
  ::v-deep .el-input__inner {
    padding-left: 44px;
  }
  ::v-deep .el-input__prefix {
    width: 20px;
    height: 20px;
    margin: 8px 12px 8px 12px;
    .icon {
      width: 20px;
      height: 20px;
    }
  }
}

// 新增按钮
.button_add {
  padding: 10px 16px;
}

// 下载按钮
.button_download {
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  padding: 10px 12px;
}

.link {
  color: #3a89ff;
}

.line {
  display: inline-block;
  width: 2px;
  height: 16px;
  background: #ccc;
  vertical-align: middle;
  margin: 0 3px 3px;
}

// 表格固定 滚动
// .grayTableTile_02 ::v-deep .el-table__body-wrapper {
//     z-index: 1;
// }

::v-deep .el-table__fixed {
  height: 623px !important;
}
::v-deep .el-table__fixed-right {
  height: 623px !important;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  height: 10px; // 纵向滚动条 必写
}
// 滚动条的滑块
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 5px;
}

// table 定位有条线
::v-deep .el-table__fixed-right:before,
::v-deep .el-table__fixed:before {
  background-color: transparent;
}

.select-box {
  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 60%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .el-select__input {
      margin-left: 2px;
    }
  }
  ::v-deep .el-select-dropdown__item {
    padding: 0 20px 0 10px;
  }
  ::v-deep .el-select-dropdown__item.selected::after {
    right: 5px;
  }
}

.dateClass {
  ::v-deep .el-icon-date:before {
    content: url("../../assets/date.png");
    position: absolute;
    top: 6px;
    left: 10px;
  }
}

.liClass {
  display: block;
  line-height: 35px;
}
</style>
